import * as i0 from "@angular/core";
export class BlogService {
    constructor() {
        this.activeTab = '';
        console.log(this.activeTab);
    }
    setActiveTab(tab) {
        this.activeTab = tab;
    }
    getActiveTab() {
        console.log(this.activeTab);
        return this.activeTab;
    }
}
BlogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BlogService_Factory() { return new BlogService(); }, token: BlogService, providedIn: "root" });
